import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function Error404() {
  return (
    <>
      <SEO title="Siden blev ikke fundet" description="Fejl 404 - Siden blev ikke fundet hos Tømrermester Mikkel Juler ApS." />

      <section className="bg-brand-cream min-h-[60vh] flex items-center justify-center py-16 px-4">
        <div className="max-w-md w-full text-center space-y-6 bg-white p-8 sm:p-12 rounded-2xl border border-gray-100 shadow-md">
          <div className="w-20 h-20 bg-brand-wood-light text-brand-wood-dark rounded-full flex items-center justify-center text-4xl mx-auto">
            <i className="fa-solid fa-triangle-exclamation" />
          </div>
          <div className="space-y-2">
            <h1 className="text-4xl font-bold text-brand-dark">404</h1>
            <h2 className="text-xl font-bold text-brand-dark-light">Siden blev ikke fundet</h2>
          </div>
          <p className="text-gray-500 text-sm leading-relaxed">
            Beklager, men den side du leder efter findes ikke længere, eller er blevet flyttet. Brug menuen ovenfor eller klik på knappen herunder for at komme tilbage til forsiden.
          </p>
          <div className="pt-4">
            <Link 
              to="/" 
              className="inline-block w-full bg-brand-green hover:bg-brand-green/90 text-white font-semibold py-3 px-6 rounded-xl transition-colors text-sm cursor-pointer"
            >
              Gå til forsiden
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
